module.exports = __webpack_public_path__ + "static/features_01-17d53ea5d3429b2aebf306264500d5d6.png";